module.exports = __webpack_public_path__ + "static/media/investor-registrationcw.ea716c4.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/website/video/investor-registrationcw.mp4
// module id = hIvq
// module chunks = 1